import { render, staticRenderFns } from "./motReclamo.vue?vue&type=template&id=24267178&scoped=true"
import script from "./motReclamo.vue?vue&type=script&lang=js"
export * from "./motReclamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24267178",
  null
  
)

export default component.exports